import { render, staticRenderFns } from "./CameraSettings.vue?vue&type=template&id=422bea6c&scoped=true&"
import script from "./CameraSettings.vue?vue&type=script&lang=js&"
export * from "./CameraSettings.vue?vue&type=script&lang=js&"
import style0 from "./CameraSettings.vue?vue&type=style&index=0&id=422bea6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422bea6c",
  null
  
)

component.options.__file = "CameraSettings.vue"
export default component.exports